module.exports = __webpack_public_path__ + "static/developpement-c68b7c4d56161eb4a59049ae40b93aac.jpg";